import * as React from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Tone, toneClasses } from '@/lib/tones';

const sizes = {
    sm: 'h-8 w-8 rounded-lg [&_svg]:size-4',
    md: 'h-10 w-10 rounded-lg [&_svg]:size-5',
    lg: 'h-12 w-12 rounded-xl [&_svg]:size-6',
};

interface IconTileProps extends React.HTMLAttributes<HTMLDivElement> {
    icon: LucideIcon;
    tone?: Tone;
    size?: keyof typeof sizes;
}

/** Square tinted container for an icon — the standard way to give a card, row or stat an anchor. */
export const IconTile: React.FC<IconTileProps> = ({ icon: Icon, tone = 'neutral', size = 'md', className, ...props }) => (
    <div
        className={cn('flex shrink-0 items-center justify-center', sizes[size], toneClasses[tone].tile, className)}
        aria-hidden
        {...props}
    >
        <Icon />
    </div>
);
